import styled, { css } from 'styled-components';

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 0;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px;
  color: ${props => props.theme.primaryDark};
  font-size: 18px;
`;

export const Infos = styled.div`
  width: fit-content;
  gap: 1.875rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const InfosVariant = styled.div`
  width: 100%;
  display: flex;
  margin: 10px;
  align-items: center;
  justify-content: space-around;
`;

export const PhotoView = styled.div`
  gap: 10px;
  width: 150px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const LinkProfile = styled.a`
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  color: ${props => props.theme.primary};

  :hover {
    color: ${props => props.theme.primaryDark};
  }
`;

export const UserInfo = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  gap: 15px;
`;

const Variant = css`
  font-size: 14px;
  text-align: left;
  display: flex;
  gap: 5px;
  justify-content: left;
  max-width: 100%;
  align-items: flex-start;
  color: ${props => props.theme.typographyDarkGray};
  .info {
    font-weight: bold;
    display: block;
    max-width: 100%;
    color: black;
  }

  @media (max-width: 1066px) {
    width: fit-content;
    justify-content: flex-start;
  }
`;

export const Name = styled.div`
  ${Variant}
`;

export const NameVariant = styled.div`
  ${Variant}
  text-align: center;
`;

export const Address = styled.div`
  ${Variant}
`;

export const Contact = styled.div`
  ${Variant}
`;

export const Email = styled.div`
  ${Variant}
`;

export const Age = styled.div`
  ${Variant}
`;
